module.exports = "/static/assets/7fe26de7358fc4e31261bb1e8038751b.png";